import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function PrimaryRecipientErrorModalTemplate({ primaryRecipientErrorModalStore}) {
    const {
        isDoneCheck,
        isLoading,
        missingName
    } = primaryRecipientErrorModalStore;

    return (
        <section>
            <div className={'modal__body type--center'}>
                <i className="status--sqare modal-warning u-mar--bottom--med u-radius--full" />
                <h3 className='modal__header__title'>{`No recipients specified for ${missingName} Email.`}</h3>
                <p className='type--base  u-mar--top--med u-mar--bottom--med type--color--secondary'>{`Please choose contacts to include on the ${missingName} Email on the Facility Preview page.`}</p>
            </div>

            <div className={'modal__footer is-center'}>
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={"Done"}
                    disabled={isLoading}
                    onClick={() => isDoneCheck()}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

PrimaryRecipientErrorModalTemplate.propTypes = {
    primaryRecipientErrorModalStore: PropTypes.object
};

export default defaultTemplate(PrimaryRecipientErrorModalTemplate);
